import graphql__e17d5b314f44f3c8a5c1 from "./__generated__/InterviewIntroSection_answer.graphql.js";import { graphql, useFragment } from "react-relay";
import { defineMessages } from "react-intl";

import { useFormatMessage } from "../Intl/Context";
import Button from "../Buttons/Button";
import InterviewStateCard from "./InterviewStateCard";

const InterviewIntroSection = ({ onStartMicroCheck, ...props }) => {
  const { formField } = useFragment(InterviewIntroSection_answer, props.answer);
  const t = useFormatMessage();
  const badge = t(intlMessages.introBadge);
  const title = t(intlMessages.introTitle);
  const description = formField.hint || t(intlMessages.introDescription);
  const startLabel = t(intlMessages.startMicroCheck);

  return (
    <InterviewStateCard state="idle" className="oral-interview-intro">
      <div className="text-legend margin-bottom-xxs">{badge}</div>

      <h4 className="oral-interview-intro__title margin-bottom-xs">{title}</h4>

      <p className="margin-bottom-xs">{description}</p>

      <Button
        type="button"
        className="btn btn-primary oral-interview-primary-cta"
        onClick={onStartMicroCheck}
        label={startLabel}
      />
    </InterviewStateCard>
  );
};

const InterviewIntroSection_answer = graphql__e17d5b314f44f3c8a5c1;

export default InterviewIntroSection;

const intlMessages = defineMessages({
  introBadge: {
    id: "answer.oralInterview.introBadge",
    defaultMessage: "ENTRETIEN VOCAL IA"
  },
  introDescription: {
    id: "answer.oralInterview.introDescription",
    defaultMessage:
      "Une IA vous guide dans un court entretien vocal pour approfondir votre réponse."
  },
  introTitle: {
    id: "answer.oralInterview.introTitle",
    defaultMessage: "Partagez votre point de vue"
  },
  startMicroCheck: {
    id: "answer.oralInterview.startMicroCheck",
    defaultMessage: "Démarrer le test micro"
  }
});
